"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.camelCaseToSentence = exports.concatCommentsIfExisting = exports.findDifferencesBetweenVersions = exports.omitNull = exports.checkWeightOutsideLimits = exports.getScaleReadingLimitHigh = exports.getScaleReadingLimitLow = exports.scaleReadingOutsideLimits = exports.validateNumericValues = exports.between = exports.timeShiftStarts = exports.isDateBeforeEndShiftPlus6 = exports.isDate1BeforeDate2 = exports.getShiftDayForNextShift = exports.nicelyDisplayDateFromISOString = exports.getDateTimeTimeZone = exports.dateTimeFromISOString = exports.nowDateTimeISOString = exports.nowDateTime = exports.shiftDayStringToDateTime = exports.shiftDayDateTimeToString = void 0;
const lodash_1 = __importDefault(require("lodash"));
const interfaces_1 = require("./interfaces");
const luxon_1 = require("luxon");
function shiftDayDateTimeToString(date) {
    return date.toISODate();
}
exports.shiftDayDateTimeToString = shiftDayDateTimeToString;
function shiftDayStringToDateTime(date) {
    //date is formatted as YYYY-MM-DD
    const [year, month, day] = date.split("-").map((s) => parseInt(s));
    if (isNaN(year) || isNaN(month) || isNaN(day) || month < 1 || month > 12 || day < 1 || day > 31 || date.length !== 10) {
        return null;
    }
    return luxon_1.DateTime.fromObject({ day, year, month }, { zone: getDateTimeTimeZone() });
}
exports.shiftDayStringToDateTime = shiftDayStringToDateTime;
function nowDateTime() {
    return luxon_1.DateTime.now().setZone(getDateTimeTimeZone());
}
exports.nowDateTime = nowDateTime;
function nowDateTimeISOString() {
    var _a;
    return (_a = nowDateTime().toISO()) !== null && _a !== void 0 ? _a : new Date().toISOString();
}
exports.nowDateTimeISOString = nowDateTimeISOString;
function dateTimeFromISOString(dateString) {
    return luxon_1.DateTime.fromISO(dateString).setZone(getDateTimeTimeZone());
}
exports.dateTimeFromISOString = dateTimeFromISOString;
function getDateTimeTimeZone() {
    return "America/New_York";
}
exports.getDateTimeTimeZone = getDateTimeTimeZone;
function nicelyDisplayDateFromISOString(date) {
    if (!date) {
        return "";
    }
    return luxon_1.DateTime.fromISO(date).setLocale("en-US").toLocaleString(luxon_1.DateTime.DATETIME_SHORT);
}
exports.nicelyDisplayDateFromISOString = nicelyDisplayDateFromISOString;
function getShiftDayForNextShift(dayCurrentShift, previousDayInsteadOfNext) {
    const format = "yyyy-MM-dd";
    if (previousDayInsteadOfNext) {
        return luxon_1.DateTime.fromISO(dayCurrentShift, { zone: "utc" }).minus({ days: 1 }).toFormat(format);
    }
    return luxon_1.DateTime.fromISO(dayCurrentShift, { zone: "utc" }).plus({ days: 1 }).toFormat(format);
}
exports.getShiftDayForNextShift = getShiftDayForNextShift;
function isDate1BeforeDate2(date1String, date2String) {
    // date is an iso string. check if date1 is before date2
    const date1 = luxon_1.DateTime.fromISO(date1String);
    const date2 = luxon_1.DateTime.fromISO(date2String);
    return date1 < date2;
}
exports.isDate1BeforeDate2 = isDate1BeforeDate2;
function isDateBeforeEndShiftPlus6(dateString, shift) {
    const date = luxon_1.DateTime.fromISO(dateString);
    const endShift = timeShiftStarts(shift, 18);
    if (!endShift) {
        return false;
    }
    return date < endShift;
}
exports.isDateBeforeEndShiftPlus6 = isDateBeforeEndShiftPlus6;
function timeShiftStarts(shift, addHours) {
    if (!shift.day) {
        return null;
    }
    let dateShift = shiftDayStringToDateTime(shift.day);
    if (!dateShift) {
        return null;
    }
    if (shift.team === interfaces_1.Team.D) {
        dateShift = dateShift.plus({ hours: 7 });
    }
    else if (shift.team === interfaces_1.Team.N) {
        dateShift = dateShift.plus({ hours: 19 });
    }
    if (addHours) {
        if (addHours < 0) {
            dateShift = dateShift.minus({ hours: Math.abs(addHours) });
        }
        else {
            dateShift = dateShift.plus({ hours: addHours });
        }
    }
    return dateShift;
}
exports.timeShiftStarts = timeShiftStarts;
function between(value, min, max) {
    return value >= min && value <= max;
}
exports.between = between;
function validateNumericValues(...items) {
    for (let item of items) {
        if (!Number.isFinite(Number(item))) {
            throw new Error(`Invalid parameter: not a number.`);
        }
    }
}
exports.validateNumericValues = validateNumericValues;
// to check the difference between the target net weight and the actual pallet
function scaleReadingOutsideLimits(targetNetWeight, measuredWeight) {
    return !between(measuredWeight, getScaleReadingLimitLow(targetNetWeight), getScaleReadingLimitHigh(targetNetWeight));
}
exports.scaleReadingOutsideLimits = scaleReadingOutsideLimits;
function getScaleReadingLimitLow(targetNetWeight) {
    return Math.round(Number((targetNetWeight * 0.995).toFixed(2)));
}
exports.getScaleReadingLimitLow = getScaleReadingLimitLow;
function getScaleReadingLimitHigh(targetNetWeight) {
    return Math.round(Number((targetNetWeight * 1.005).toFixed(2)));
}
exports.getScaleReadingLimitHigh = getScaleReadingLimitHigh;
// to check that the scale has no issue
function checkWeightOutsideLimits(measuredWeight, checkWeight) {
    return Math.abs(measuredWeight - checkWeight) > 3;
}
exports.checkWeightOutsideLimits = checkWeightOutsideLimits;
function omitNull(obj) {
    if (lodash_1.default.isArray(obj)) {
        return obj.map(omitNull);
    }
    if (lodash_1.default.isPlainObject(obj)) {
        return lodash_1.default.omitBy(lodash_1.default.mapValues(obj, omitNull), lodash_1.default.isNull);
    }
    return obj;
}
exports.omitNull = omitNull;
function findDifferencesBetweenVersions(oldVersion, newVersion) {
    let differences = {};
    // Combine the keys from both versions
    const allKeys = new Set([...Object.keys(oldVersion), ...Object.keys(newVersion)]);
    allKeys.forEach((key) => {
        if (!lodash_1.default.isEqual(oldVersion[key], newVersion[key])) {
            differences[key] = {
                oldValue: oldVersion[key],
                newValue: newVersion[key],
            };
        }
    });
    return differences;
}
exports.findDifferencesBetweenVersions = findDifferencesBetweenVersions;
function concatCommentsIfExisting(oldComment, newComment) {
    let finalComment = oldComment == null ? "" : oldComment;
    if (newComment != null && newComment !== "") {
        if (finalComment !== "") {
            finalComment += "\n\n";
        }
        finalComment += newComment;
    }
    return finalComment;
}
exports.concatCommentsIfExisting = concatCommentsIfExisting;
function camelCaseToSentence(input) {
    return input
        .replace(/([A-Z])/g, " $1")
        .toLowerCase()
        .replace(/^./, (str) => str.toUpperCase());
}
exports.camelCaseToSentence = camelCaseToSentence;
